import { render, staticRenderFns } from "./TradeTicket.vue?vue&type=template&id=0540fcb8&scoped=true&"
import script from "./TradeTicket.vue?vue&type=script&lang=js&"
export * from "./TradeTicket.vue?vue&type=script&lang=js&"
import style0 from "./TradeTicket.vue?vue&type=style&index=0&id=0540fcb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0540fcb8",
  null
  
)

export default component.exports